// extracted by mini-css-extract-plugin
export default {"getRisk":"getRisk_getRisk__98rfI","low":"getRisk_low__TmBoL","medium":"getRisk_medium__OIkH7","high":"getRisk_high__bj-aF"};